import SocialLinks from '@stories/Components/Misc/SocialLinks/SocialLinks';
import * as React from 'react';
import S from './NavigationContactBlock.styles';
const NavigationContactBlock = (props) => {
    return (React.createElement(S.NavigationContactInfo, { as: props.as },
        props.telephone && (React.createElement(S.NavigationContact, null,
            React.createElement("span", null,
                props.translations?.['contact.telephone'] ?? 'Telephone',
                ":"),
            ' ',
            React.createElement("a", { href: props.telephone.url, target: "_blank", rel: "noreferrer" }, props.telephone.text))),
        props.email && (React.createElement(S.NavigationContact, null,
            React.createElement("span", null,
                props.translations?.['contact.email'] ?? 'Email',
                ":"),
            ' ',
            React.createElement("a", { href: props.email.url, target: "_blank", rel: "noreferrer" }, props.email.text))),
        props.socialLinks && (React.createElement("div", null,
            React.createElement(SocialLinks, { items: props.socialLinks })))));
};
export default NavigationContactBlock;
